/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable @next/next/no-img-element */
import { ChangeEvent, Fragment, KeyboardEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Markdown from "markdown-to-jsx";
import { useRouter } from "next/router";
import { format, isSameDay } from "date-fns";
import { v4 as uuidv4 } from 'uuid';

import { ArrowUpIcon, CalendarIcon, EllipsisIcon, FilterIcon, InfoIcon, LightbulbIcon, Loader2, MessageCirclePlusIcon, PencilIcon, Trash2Icon } from "lucide-react"
import { Button } from "../ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown";
import { Input } from "../ui/input";
import { RootState } from "../../store/reducers";
import { cn } from "../../lib/utils";
import { Skeleton } from "../ui/skeleton";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from "../ui/sheets";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordian";
import { getCRMStatus } from "../../handlers/handlers";
import { STATUSES } from "../../store/types";
import { Calendar } from "../ui/calendar";
import CortexService from "../../services/cortex/cortex.service";
import { Dialog, DialogContent, DialogFooter } from "../ui/dialog";
import ThreeDotLoader2 from "../loader/three-dots-loader";

type Props = {}

type Thread = {
  id: string;
  title: string;
}

type ThreadDetail = {
  qid: string;
  query: string;
  final_answer: string;
  completed_at: string;
}

type LeftPanelProps = {
  list: Thread[];
  loading: boolean;
  selected: string;
  setSelected: (val: string) => void;
  setFiltersApplied: (val: boolean) => void;
  setFilters: (val:{[key:string]: any}) => void;
  fetchThreadList: () => void;
  stopPolling: () => void;
}

type ChatInterfaceProps = {
  thread: ThreadDetail[];
  loading: boolean;
  setThread: (thread: ThreadDetail[]) => void;
  filters: {[key:string]: any}
  setFilters: (val:{[key:string]: any}) => void;
  filtersApplied: boolean;
  setFiltersApplied: (val: boolean) => void;
  fetchThreadList: () => void;
  shouldNotFetchDetails: (val: boolean) => void
  startPolling: (id: string) => void;
}

type ThreadItemProps = Thread & {
  selected: string;
  setSelected: (val: string) => void;
  handleThreadDelete: (id: string) => void;
}

type ChatProps = ThreadDetail & {
  role: string;
  idx: number;
}

type ThreeDotLoaderProps = React.HTMLAttributes<HTMLDivElement>

type SuggestionProps = {
  text: string;
  setInputText: (text: string) => void
}

type DeleteThreadModalProps = {
  open: boolean;
  setOpen: (val: boolean) => void;
  loading: boolean;
  handleDeleteConfirm: () => void;
  setDeleteId: (id: string) => void;
}

const QueryEngine = (props: Props) => {
  const { selectedWorkspace } = useSelector((state: RootState) => state.common);
  const { replace } = useRouter();
  const [threadList, setThreadList] = useState<Thread[]>([]);
  const [threadListLoading, setThreadListLoading] = useState<boolean>(false);
  const [selectedThreadId, setSelectedThreadId] = useState<string>();
  const [thread, setThread] = useState<ThreadDetail[]>();
  const [threadLoading, setThreadLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<{[key:string]: any}>();
  const [filterApplied, setFilterApplied] = useState<boolean>(false);
  const shouldNotFetchRef = useRef<boolean>(false);
  const pollingRef = useRef<number>();

  function isObjectEmpty(obj) {
    if (obj === null || obj === undefined) return true;
    if (typeof obj !== 'object') return false;
    if (Array.isArray(obj)) {
      return obj.length === 0;
    }
    return Object.keys(obj).every((key) => isObjectEmpty(obj[key]));
  }

  const fetchThreadList = async () => {
    try {
      setThreadListLoading(true);
      const response = await CortexService.getThreadList(selectedWorkspace?.[0]?.id);
      const data = response?.data?.data;
      setThreadList(data);
      const currUrl = new URL(window.location.href);
      const tid = currUrl.searchParams.get('tid');
      const tab = currUrl.searchParams.get('tab');
      if (tid && data?.length) {
        const threadData = data.filter(thr => thr.id === tid);
        if (threadData?.[0]?.id) {
          setSelectedThreadId(threadData?.[0]?.id);
        } else {
          replace(`reports?tab=${tab}`);
        }
      } else if (tab) {
        replace(`reports?tab=${tab}`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setThreadListLoading(false);
    }
  }

  const fetchThreadDetail = async (id?: string) => {
    try {
      setThreadLoading(!id );
      const response = await CortexService.getThreadDetails(id || selectedThreadId);
      const data = response?.data?.data;
      setThread(data || []);
      setFilters(data?.[0]?.filters);

      if (typeof data?.[0]?.filters === 'object' && !isObjectEmpty(data?.[0]?.filters)) {
        setFilterApplied(true);
      } else {
        setFilterApplied(false);
      }

      const isIncomplete = (data || []).some((query) => !query.completed_at);
      if (isIncomplete) {
        startPolling(id || selectedThreadId);
      } else {
        stopPolling();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setThreadLoading(false);
    }
  }

  const startPolling = (id: string) => {
    stopPolling();
    pollingRef.current = window.setInterval(() => {
      fetchThreadDetail(id);
    }, 20000)
  }

  const stopPolling = () => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
    }
  }

  const shouldNotFetchDetails = (val: boolean) => {
    shouldNotFetchRef.current = val;
  }

  useEffect(() => {
    if (shouldNotFetchRef.current) {
      shouldNotFetchDetails(false);
      return;
    }
    if (selectedThreadId) {
      fetchThreadDetail();
    } else {
      setThread([]);
    }
  }, [selectedThreadId]);

  useEffect(() => {
    fetchThreadList();
    return () => {
      stopPolling();
    }
  }, [])

  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="flex w-full h-full overflow-y-auto">
        <LeftPanel
          list={threadList}
          selected={selectedThreadId}
          setSelected={setSelectedThreadId}
          loading={threadListLoading}
          setFilters={setFilters}
          setFiltersApplied={setFilterApplied}
          fetchThreadList={fetchThreadList}
          stopPolling={stopPolling}
        />
        <ChatInterface
          thread={thread}
          loading={threadLoading}
          setThread={setThread}
          filters={filters}
          setFilters={setFilters}
          filtersApplied={filterApplied}
          setFiltersApplied={setFilterApplied}
          fetchThreadList={fetchThreadList}
          shouldNotFetchDetails={shouldNotFetchDetails}
          startPolling={startPolling}
        />
      </div>
    </div>
  )
}

const LeftPanel = ({ list, loading, setFiltersApplied, setFilters, fetchThreadList, stopPolling, ...rest }: LeftPanelProps) => {
  const { replace, query } = useRouter();
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>('');
  const [deleting, setDeleting] = useState<boolean>(false);

  const handleThreadDelete = (id: string) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setDeleting(true);
      setDeleteId('');
      await CortexService.deleteThread(deleteId);
      fetchThreadList();
    } catch (error) {
      console.log(error)
    } finally {
      setDeleting(false);
    }
  }

  const handleNewQueryClick = () => {
    stopPolling();
    replace(`/reports?tab=${query?.tab}`);
    rest.setSelected(undefined);
    setFilters(null);
    setFiltersApplied(false);
  }

  const SkeletonLoader = () => {
    return (
      <div className="w-full flex flex-col gap-2 mt-4">
        <Skeleton className="h-7 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
        <Skeleton className="h-7 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
        <Skeleton className="h-7 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mx-4" />
      </div>
    )
  }

  return (
    <div className="w-[30%] max-w-[230px] flex flex-col overflow-y-auto">
      <div className="w-full py-4.5 px-4">
        <Button
          type="button"
          variant="outline"
          className="w-full bg-[#F2F4F8] hover:bg-[#F2F4F8] rounded-lg flex justify-between items-center p-2 font-bold"
          onClick={handleNewQueryClick}
        >
          New Query
          <MessageCirclePlusIcon />
        </Button>
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto">
        <span className="text-sm text-[#878787] px-4 py-1">All threads</span>
        {Boolean(list?.length) && (
          <>
            {loading ? (
              <SkeletonLoader />
            ) : (
              <ul className="flex-1 overflow-y-auto">
                {list.map(thread => (
                  <ThreadItem
                    key={thread.id}
                    handleThreadDelete={handleThreadDelete}
                    {...thread}
                    {...rest}
                  />
                ))}
              </ul>
            )}
          </>
        )}
      </div>
      <DeleteThreadModal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        handleDeleteConfirm={handleDeleteConfirm}
        setDeleteId={setDeleteId}
        loading={deleting}
      />
    </div>
  )
}

const ChatInterface = ({ thread, loading, setThread, fetchThreadList, shouldNotFetchDetails, startPolling, ...rest }: ChatInterfaceProps) => {
  const { allUsers, selectedWorkspace } = useSelector((state: RootState) => state.common);
  const { query, replace } = useRouter();
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isNew, setIsNew] = useState<boolean>(true);
  const [queryText, setQueryText] = useState<string>('');
  const [filterMenuOpen, setFilterMenuOpen] = useState<boolean>(false);
  const [filterTooltip, setFilterTooltip] = useState<{[key:string]: any}>();
  const [fetching, setFetching] = useState<boolean>(false);

  const handleQueryFldOnChange = (e: ChangeEvent<HTMLInputElement>) => setQueryText(e.target.value);

  const handleFilterBtnMouseEnter = () => setIsHovered(true);

  const handleFilterBtnMouseLeave = () => setIsHovered(false);

  const handleFilterBtnClick = () => setFilterMenuOpen(true);

  const handleQueryFldOnKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleQuery();
    }
  }

  const handleQuery = async () => {
    try {
      setFetching(true);
      const id = query?.tid ? query?.tid?.toString() : uuidv4();
      const payload: ThreadDetail = {
        qid: id,
        query: queryText,
        final_answer: '',
        completed_at: null
      };
      const newThread = [...thread, payload];
      await CortexService.postQuery(selectedWorkspace?.[0]?.id, id, { query: queryText, filters: rest.filters });
      setQueryText('');
      setThread(newThread);
      if (!query?.tid) {
        shouldNotFetchDetails(true);
        replace(`/reports?tab=${query?.tab}&tid=${id}`);
        setTimeout(() => {
          fetchThreadList();
        }, 100);
      } else {
        setTimeout(() => {
          const elm = document.querySelector(`#query_${thread.length + 1}_sys_msg`);
          if (elm) {
            elm.scrollIntoView({ block: 'end', behavior: "smooth"})
          }
        }, 200);
      }
      setTimeout(() => {
        startPolling(id);
      }, 200)
    } catch (error) {
      console.log(error)
    } finally {
      setFetching(false);
    }
  }

  const getFilterTitle = (itm: string) => {
    switch(itm) {
      case 'user_id':
        return 'Agent Name';
      case 'status':
        return 'Status'
      case 'date_filter':
        return 'Date'
      default:
        return <></>
    }
  }

  const SkeletonLoader = () => {
    return (
      <div className="w-full flex flex-col gap-2 mt-4">
        <div className="flex items-center gap-6 mb-6 justify-end">
          <Skeleton className="h-14 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <div className="flex items-center gap-6 mb-6">
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-28 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <div className="flex items-center gap-6 mb-6 justify-end">
          <Skeleton className="h-10 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <div className="flex items-center gap-6">
          <Skeleton className="h-7 w-7 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="h-20 w-[80%] rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
        <Skeleton className="h-14 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7] mt-6"/>
      </div>
    )
  }

  useEffect(() => {
    if (rest.filtersApplied && Object.keys(rest.filters)?.length) {
      const objectItem = {}
      Object.keys(rest.filters).map((filter) => {
        if (filter === 'user_id' && rest.filters?.[filter]?.length) {
          const set = new Set(rest.filters?.[filter]);
          const names = allUsers.filter(user => set.has(user.user_id)).map(user => `${user?.first_name || ''}${user?.last_name ? ` ${user?.last_name}` : ''}`);
          objectItem[filter] = names;
        } else {
          objectItem[filter] = rest.filters?.[filter];
        }
      });
      setFilterTooltip(objectItem);
    }
  }, [rest.filtersApplied, rest.filters]);

  useEffect(() => {
    if (thread?.length)
      setIsNew(false);
    else
      setIsNew(true);
  }, [thread]);

  return (
    <div className="w-full border-l border-[#DDE1E6] h-full flex justify-center pb-6 relative">
      <div className={`w-[90%] max-w-[882px] h-full flex flex-col items-center relative ${isNew && !loading ? 'justify-center' : 'justify-end'}`}>
        {loading ? (
          <SkeletonLoader />
        ) : (
          <>
            {Boolean(thread?.length) && (
              <div id="scroll" className="w-full flex flex-col overflow-y-auto flex-1 px-1.5">
                <div className="mt-auto flex flex-col">
                  {thread.map((msg, idx) => (
                    <Fragment key={msg.qid}>
                      <Chat idx={idx + 1} role='user' {...msg} />
                      <Chat idx={idx + 1} role='system' {...msg} />
                    </Fragment>
                  ))}
                </div>
              </div>
            )}
            <div className={`${!isNew ? 'w-full sticky bottom-0 pt-2' : 'w-[90%] max-w-[600px] relative gap-6'} flex flex-col transition-all duration-300`}>
              {isNew && <div className="font-bold text-xl text-center">How can I help you today?</div>}
              {rest.filtersApplied && (
                <div className="w-full flex items-center justify-between mb-2">
                  <div className="text-sm font-semibold">Filters Applied-</div>
                  <div className="flex items-center gap-2.5">
                    {filterTooltip && Object.keys(filterTooltip)?.length && Object.keys(filterTooltip)?.map((filter) => (
                      <DropdownMenu key={filter} modal={false}>
                        <DropdownMenuTrigger asChild>
                          <div key={filter} className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg flex items-center gap-4 p-2 text-xs font-medium cursor-pointer">
                            {getFilterTitle(filter)}
                            <InfoIcon />
                          </div>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent
                          align="start"
                          side='top'
                          className='w-[200px] bg-[#F8FAFC] p-2 py-1 rounded-xl
                          border-[#E2E8F0] data-[state=closed]:hidden'
                        >
                          {filterTooltip?.[filter]?.length ? (
                            <>
                              {filterTooltip?.[filter].map(itm => {
                                if (itm) {
                                  return (
                                    <DropdownMenuItem
                                      key={itm}
                                      className='flex items-center px-3 py-2.5 w-full'
                                    >
                                      <span className="text-sm">{itm}</span>
                                    </DropdownMenuItem>
                                  )
                                } else {
                                  return []
                                }
                              })}
                            </>
                          ) : (
                            <>
                              {filterTooltip?.[filter] && Object.keys(filterTooltip?.[filter])?.length ? (
                                <>
                                  <DropdownMenuItem className='flex items-center px-3 py-2.5 w-full'>
                                    <span className="text-sm">
                                      From: {filterTooltip?.[filter]?.start && format(new Date(filterTooltip?.[filter]?.start), 'dd/MM/yyy')}
                                    </span>
                                  </DropdownMenuItem>
                                  <DropdownMenuItem className='flex items-center px-3 py-2.5 w-full'>
                                    <span className="text-sm">
                                      To: {filterTooltip?.[filter]?.end && format(new Date(filterTooltip?.[filter]?.end), 'dd/MM/yyy')}
                                    </span>
                                  </DropdownMenuItem>
                                </>
                              ) : []}
                            </>
                          )}

                        </DropdownMenuContent>
                      </DropdownMenu>
                    ))}
                  </div>
                </div>
              )}
              <div className="relative w-full">
                <Input
                  value={queryText}
                  className={`h-auto rounded-full px-16 py-4.5 placeholder:font-semibold focus:ring-0 relative transition-[padding] duration-300
                  focus-visible:outline-0 focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-0 ${isHovered ? 'pl-[128px]' : ''}
                  border-[#CBD5E1] focus:border-[#CBD5E1]`}
                  placeholder="Type Here"
                  onChange={handleQueryFldOnChange}
                  onKeyPress={handleQueryFldOnKeyDown}
                />
                <Button
                  variant="outline"
                  className="bg-[#F8FAFC] h-10 rounded-full border border-[#E2E8F0]
                  absolute top-1/2 left-2 p-2 flex items-center justify-center -translate-y-1/2
                  transition-all group duration-300 max-w-[40px] hover:max-w-xs disabled:border-0"
                  onMouseEnter={handleFilterBtnMouseEnter}
                  onMouseLeave={handleFilterBtnMouseLeave}
                  disabled={Boolean(thread?.length)}
                  onClick={handleFilterBtnClick}
                >
                  <FilterIcon className="text-[#878787] min-w-[24px]"/>
                  <span className="max-w-0 group-hover:max-w-xs text-xs font-normal overflow-hidden transition-all duration-300 group-hover:pl-2">
                    Apply Filters
                  </span>
                </Button>
                <Button
                  variant="outline"
                  className="bg-primary w-10 h-10 rounded-full border border-[#E2E8F0]
                  absolute top-1/2 right-2 p-0 flex items-center justify-center -translate-y-1/2"
                  onClick={handleQuery}
                  disabled={fetching}
                >
                  {fetching ? <Loader2 className="text-white animate-spin" /> : <ArrowUpIcon className="text-white"/>}
                </Button>
              </div>
              {isNew && (
                <div className="w-full flex flex-col gap-2">
                  <div className="flex items-center gap-2 text-[#878787] font-bold">
                    <LightbulbIcon />
                    Suggestions
                  </div>
                  <div className={`suggestion-cnt flex items-center gap-4 text-xs text-[#1C1C1C] overflow-x-auto ${fetching ? 'pointer-events-none' : 'pointer-events-auto'}`}>
                    <Suggestion
                      text="What are the common concerns raised by my customers?"
                      setInputText={setQueryText}
                    />
                    <Suggestion
                      text="Which audit parameters have the lowest scores and what can be done to improve?"
                      setInputText={setQueryText}
                    />
                    <Suggestion
                      text="What are my low intent customers saying about pricing?"
                      setInputText={setQueryText}
                    />
                  </div>
                  <style jsx>{`
                    .suggestion-cnt {
                      -ms-overflow-style: none;
                      scrollbar-width: none;
                    }
                    .suggestion-cnt::-webkit-scrollbar {
                      display: none;
                    }
                  `}</style>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <HardFilterSection open={filterMenuOpen} setOpen={setFilterMenuOpen} {...rest} />
    </div>
  );
}

const SalesAgentFilter = ({item, users, filters, handleFiltersSet}) => {
  return (
    <div>
      {users && users.map((user) => (
        <div
          key={user?.user_id}
          className="flex justify-start py-2 cursor-pointer"
          onClick={() => handleFiltersSet(item, user?.user_id)}
        >
          <input
            type="checkbox"
            checked={filters && Array.isArray(filters) && filters.includes(user?.user_id)}
            className="form-checkbox h-3.5 w-3.5 lg:h-4 lg:w-4 text-secondary focus:ring-transparent cursor-pointer rounded-sm border-secondary"
            name={user?.user_id}
            value={user?.user_id}
            id={user?.user_id}
          />
          <p className="text-primary-dark text-xs lg:text-sm font-medium leading-4 mx-2">
            {`${user?.first_name || ''}${
              user?.last_name
                ? ` ${user?.last_name}`
                : ''
            }`}
          </p>
        </div>
      ))}
    </div>
  )
}

const StatusFilter = ({item, statuses, filters, handleFiltersSet, loading}) => {
  if (!loading && !statuses?.length) {
    return <div className="text-tag-text-three text-xs">No statuses</div>
  }
  if (loading) {
    return <Loader2 className="w-4 h-4 text-secondary mx-auto my-2 animate-spin"/>
  }
  return (
    <div>
      {statuses && statuses.map((status) => (
        <div
          key={status?.id}
          className="flex justify-start py-2 cursor-pointer"
          onClick={() => handleFiltersSet(item, status?.name)}
        >
          <input
            type="checkbox"
            checked={filters && Array.isArray(filters) && filters.includes(status?.name)}
            className="form-checkbox h-3.5 w-3.5 lg:h-4 lg:w-4 text-secondary focus:ring-transparent cursor-pointer rounded-sm border-secondary"
            name={status?.id}
            value={status?.id}
            id={status?.id}
          />
          <p className="text-primary-dark text-xs lg:text-sm font-medium leading-4 mx-2">
            {status.name}
          </p>
        </div>
      ))}
    </div>
  )
}

const DateFilter = ({item, filters, handleFiltersSet}) => {
  const [selected, setSelected] = useState<'from' | 'to'>('from');
  const [fromDate, setFromDate] = useState<Date>();
  const [toDate, setToDate] = useState<Date>();

  const handleFromClick = () => setSelected('from');

  const handleToClick = () => setSelected('to');

  const handleResetBtnClick = () => {
    setFromDate(undefined);
    setToDate(undefined);
  }

  useEffect(() => {
    if (filters?.from && filters?.to && !isSameDay(fromDate, new Date(filters?.from)) && !isSameDay(toDate, new Date(filters?.to))) {
      setFromDate(new Date(filters?.from));
      setToDate(new Date(filters?.to));
    }
  }, [filters]);

  useEffect(() => {
    handleFiltersSet(item, { start: (fromDate && fromDate.toISOString()), end: (toDate && toDate.toISOString()) })
  }, [fromDate, toDate])

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center justify-center gap-4.5 w-full">
        <div className="flex flex-col gap-1 w-full">
          <label className="font-bold text-xs">From</label>
          <Button
            className={`relative bg-transparent px-3 pr-7 py-2 border rounded text-xs font-normal leading-4 hover:bg-transparent justify-start ${
              selected === 'from' ? 'border-secondary' : 'border-[#D7D7D7]'
            }`}
            onClick={handleFromClick}
          >
            {fromDate ? format(fromDate, 'dd/MM/yyyy') : ''}
            <CalendarIcon className="absolute w-4 h-4 top-1/2 -translate-y-1/2 right-3" />
          </Button>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="font-bold text-xs">To</label>
          <Button
            className={`relative bg-transparent px-3 pr-7 py-2 border rounded text-xs font-normal leading-4 hover:bg-transparent justify-start ${
              selected === 'to' ? 'border-secondary' : 'border-[#D7D7D7]'
            }`}
            onClick={handleToClick}
          >
            {toDate ? format(toDate, 'dd/MM/yyyy') : ''}
            <CalendarIcon className="absolute w-4 h-4 top-1/2 -translate-y-1/2 right-3" />
          </Button>
        </div>
      </div>
      {(fromDate && !toDate) || (!fromDate && toDate) ? (
        <div className='text-xxs text-negative-red font-normal mt-1 mx-auto'>
          Please enter from and to dates
        </div>
      ) : null}
      <div className="border border-[#D7D7D7] rounded mt-3 mb-1.5">
        <Calendar
          mode="single"
          defaultMonth={new Date()}
          selected={selected === 'from' ? fromDate : toDate}
          onSelect={selected === 'from' ? setFromDate : setToDate}
          fromDate={selected === 'to' ? fromDate : null}
          toDate={new Date()}
        />
      </div>
      <div className='ml-auto flex items-center gap-2'>
        <Button
          className='border-none bg-transparent hover:bg-transparent p-1 text-secondary text-xs font-medium h-fit'
          onClick={handleResetBtnClick}
        >
          Reset
        </Button>
      </div>
    </div>
  );
}

const HardFilterSection = ({ open, setOpen, filters, setFilters, filtersApplied, setFiltersApplied }) => {
  const { allUsers, statuses } = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();
  const [accordianOpen, setAccordianOpen] = useState<string>('');
  const [statusLoading, setStatusLoading] = useState<boolean>(false);

  function isObjectEmpty(obj) {
    if (obj === null || obj === undefined) return true;
    if (typeof obj !== 'object') return false;
    if (Array.isArray(obj)) {
      return obj.length === 0;
    }
    return Object.keys(obj).every((key) => isObjectEmpty(obj[key]));
  }

  const getCRMStatusList = async () => {
    try {
      setStatusLoading(true);
      if (statuses?.length) return;
      const data = await getCRMStatus();
      const sortedArr = data.sort((fe, se) => fe.sequence - se.sequence);
      dispatch({
        type: STATUSES,
        payload: sortedArr
      })
    } catch (err) {
      console.log('error', err.response?.data.message);
    } finally {
      setStatusLoading(false);
    }
  }

  const handleFiltersSet = (itm: string, val) => {
    const copyFilters = {...filters};
    const filter = filters?.[itm];
    if (itm === 'user_id' || itm === 'status') {
      if (!filter) {
        copyFilters[itm] = [];
        copyFilters?.[itm].push(val);
      }

      if (filter && Array.isArray(filter)) {
        if (filter.includes(val)) {
          const cpy = filter.filter(pVal => pVal !== val)
          copyFilters[itm] = cpy;
        } else {
          copyFilters?.[itm].push(val);
        }
      }
    }

    if (itm === 'date_filter') {
      copyFilters[itm] = val;
    }

    setFilters({...copyFilters});
  }

  const handleFiltersReset = () => {
    setFilters(null);
    setFiltersApplied(false);
  }

  const handleFiltersApply = () => {
    setFiltersApplied(true);
  }

  const getFilteredNumber = (itm: string) => {
    let filterAmtLength;
    switch(itm) {
      case 'status':
      case 'user_id':
        filterAmtLength = filtersApplied && filters?.[itm]?.length;
        break;
      case 'date_filter':
        filterAmtLength = filtersApplied && filters?.[itm] && Object.keys(filters?.[itm])?.length ? 1 : 0;
        break;
      default:
        filterAmtLength = 0;
        break;
    }
    if (!filterAmtLength) return <></>
    return (
      <>
        {Boolean(filterAmtLength) && (
          <div className="w-4 h-4 bg-secondary/20 rounded-full flex items-center justify-center">
            <div className="w-3 h-3 bg-secondary text-white text-[8px] font-bold rounded-full flex items-center justify-center">
              {filterAmtLength}
            </div>
          </div>
        )}
      </>
    )
  }

  const getAccordianContent = (itm: string) => {
    switch(itm) {
      case 'user_id':
        return <SalesAgentFilter item={itm} users={allUsers} filters={filters?.[itm]} handleFiltersSet={handleFiltersSet} />
      case 'status':
        return <StatusFilter item={itm} statuses={statuses} filters={filters?.[itm]} handleFiltersSet={handleFiltersSet} loading={statusLoading} />
      case 'date_filter':
        return <DateFilter item={itm} filters={filters?.[itm]} handleFiltersSet={handleFiltersSet} />
      default:
        return <></>
    }
  }

  const getAccordianTitle = (itm: string) => {
    switch(itm) {
      case 'user_id':
        return 'Agent Name';
      case 'status':
        return 'Status'
      case 'date_filter':
        return 'Date'
      default:
        return <></>
    }
  }

  useEffect(() => {
    getCRMStatusList();
  }, [])

  const accordians = ["user_id", "status", "date_filter"];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="bg-white top-[112px] h-auto p-0 flex flex-col gap-0">
        <SheetHeader className="bg-secondary px-4 py-3.5">
          <SheetTitle className="text-white font-bold text-base">
            Filters
          </SheetTitle>
          <SheetDescription className="text-white font-medium text-xs mt-1 w-[90%]">
            These help you to refine your  output in a much more efficient way
          </SheetDescription>
        </SheetHeader>
        <div className="px-4 py-5 h-full overflow-y-auto">
          <Accordion type="single" collapsible className="w-full [&>div]:mb-2">
            {accordians.map(itm => (
              <AccordionItem
                key={itm}
                value={itm}
                className={`border rounded-lg ${
                  accordianOpen === itm ? 'border-secondary' : 'border-[#d7d7d7]'
                }`}
              >
                <AccordionTrigger
                  className="text-sm font-bold px-4 py-4 hover:no-underline"
                  onClick={() => setAccordianOpen(accordianOpen === itm ? '' : itm)}
                >
                  <div className="w-full flex justify-between pr-1.5">
                    {getAccordianTitle(itm)}
                    {getFilteredNumber(itm)}
                  </div>
                </AccordionTrigger>
                <AccordionContent
                  className={`h-full ${itm === 'date_filter' ? 'max-h-[420px]' : 'max-h-[420px]'} px-4 overflow-y-auto [&>div:last-child]:pb-0`}
                >
                  {getAccordianContent(itm)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <SheetFooter className="py-4 mx-auto flex flex-row gap-4 mt-auto">
          <SheetClose asChild>
            <Button
              className="bg-secondary/20 hover:bg-secondary/20 text-secondary hover:text-secondary rounded-lg text-xs font-bold w-[140px]"
              onClick={handleFiltersReset}
            >
              Reset
            </Button>
          </SheetClose>
          <SheetClose asChild>
            <Button
              className="bg-secondary hover:bg-secondary text-white hover:text-white rounded-lg text-xs font-bold w-[140px]"
              onClick={handleFiltersApply}
              disabled={isObjectEmpty(filters)}
            >
              Apply
            </Button>
          </SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}

const ThreadItem = ({ id, title, selected, setSelected, handleThreadDelete }: ThreadItemProps) => {
  const { query, replace } = useRouter();
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const handleItemClick = () => {
    setSelected(id);
    replace(`/reports?tab=${query?.tab}&tid=${id}`)
  };

  return (
    <li
      className={`h-12 px-4 py-3 text-sm font-medium cursor-pointer flex items-center group hover:bg-[#F7F9FB] pointer-events-auto ${selected === id ? 'bg-[#F7F9FB]' : 'bg-white'}`}
      title={title}
      onClick={handleItemClick}
    >
      <span className="w-full truncate block">{title}</span>
      <DropdownMenu modal={false} open={menuOpen} onOpenChange={setMenuOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className={`hidden w-fit h-fit rounded-md bg-transparent border-none group-hover:block p-0 ${menuOpen ? 'block' : ''}`}
          >
            <EllipsisIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          side='bottom'
          className='w-[200px] bg-[#F8FAFC] max-h-[130px] p-0 py-1 rounded-xl
          border-[#E2E8F0] data-[state=closed]:hidden'
        >
          <DropdownMenuItem
            className='flex items-center gap-2.5 px-3 py-2 w-full hover:bg-[#E2E8F0] cursor-pointer'
          >
            <PencilIcon className="w-5 h-5" />
            <span className="text-sm">Rename</span>
          </DropdownMenuItem>
          <DropdownMenuItem
            className='flex items-center gap-2.5 px-3 py-2 w-full hover:bg-[#E2E8F0] cursor-pointer text-negative-red'
            onClick={() => handleThreadDelete(id)}
          >
            <Trash2Icon className="w-5 h-5" />
            <span className="text-sm">Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </li>
  )
}

const Chat = ({ idx, role, query, final_answer, completed_at }: ChatProps) => {
  const { user } = useSelector((state: RootState) => state.common);
  return (
    <div id={role === 'user' ? `query_${idx}_user_msg` : `query_${idx}_sys_msg`} className="flex gap-4 w-full mb-6">
      <span className="min-w-[65px] h-[65px] max-h-[65px] flex items-center justify-center">
        {role === 'system' && (
          <div className="pulsating-circle relative flex items-center justify-center w-[35px] h-[35px] rounded-full">
            <img
              src="/icons/zip-vector.svg"
              className="w-[20px] h-[20px] z-[2]"
              alt="pulse"
            />
            <span
              className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-1 border-[#bbe2f0]"
            />
            <span
              className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-2 border-[#bbe2f0]"
            />
            <span
              className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-2 border-[#bbe2f0]"
            />
            <span
              className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-secondary bg-opacity-80 w-full h-full m-0 p-0 border-2 border-[#bbe2f0]"
            />
          </div>
        )}
        <style jsx>{`
          .pulsating-circle {
            background: linear-gradient(135.32deg,#74adc7 -5.19%,#31667f 30.47%,#14262f 108.06%);
          }
          .pulsating-circle span {
            animation: pulse 3s ease-out infinite;
          }
          .pulsating-circle span:nth-of-type(2) {
            animation: pulse 3s ease-out infinite;
            animation-delay: 1s;
          }
          .pulsating-circle span:nth-of-type(3) {
            animation: pulse 3s ease-out infinite;
            animation-delay: 2s;
          }
          .pulsating-circle span:nth-of-type(4) {
            animation: pulse 3s ease-out infinite;
            animation-delay: 3s;
          }
          @keyframes pulse {
            100% {
              transform: scale(1.85);
              opacity: 0;
            }
          }
        `}</style>
      </span>
      <div className="w-full">
        {role === 'system' ? (
          <>
            {completed_at ? (
              <Markdown className="whitespace-pre-line [&_h1]:font-bold [&_h2]:font-bold [&_h3]:font-bold [&_h4]:font-bold [&_h5]:font-bold [&_h6]:font-bold [&_ol]:list-decimal [&_ol]:ps-[40px] [&_ul]:list-disc [&_ul]:ps-[40px]">{final_answer}</Markdown>
            ) : (
              <div className="flex flex-col gap-2">
                <ThreeDotLoader className="w-3 h-3"/>
                <div className="text-sm">Please wait, our AI is analyzing your query to deliver the best possible response.</div>
              </div>
            )}
          </>
        ) : (
          <div className="bg-[#F2F4F8] rounded-xl p-4 h-auto flex justify-end">
            {query}
          </div>
        )}
      </div>
      <span className="min-w-[30px] h-[30px] max-h-[30px]">
        {role === 'user' && (
          <img
            src={user?.avatar_url || '/icons/profile-default.svg'}
            className="rounded-full w-[30px] h-[30px] object-cover"
            alt="profile"
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '/icons/profile-default.svg';
            }}
          />
        )}
      </span>
    </div>
  )
}

const Suggestion = ({ text, setInputText }: SuggestionProps) => {
  const handleSuggestionClick = () => setInputText(text);
  return (
    <div
      className="bg-[#F8FAFC] border border-[#E2E8F0] flex p-2 rounded-lg min-h-[96px] min-w-[200px] h-full cursor-pointer"
      onClick={handleSuggestionClick}
    >
      {text}
    </div>
  )
}

const ThreeDotLoader = ({ className }: ThreeDotLoaderProps) => {
  const divClasses = cn('h-2 w-2 rounded-full scale-0 bg-black inline-block m-1', className);
  return (
    <>
      <div className="three-dot-loader flex my-0 flex-auto">
        <div className={`${divClasses}`} />
        <div className={`${divClasses}`} />
        <div className={`${divClasses}`} />
      </div>
      <style jsx>{`
        .three-dot-loader div {
          animation: scaling 1.5s ease-in-out infinite;
        }
        .three-dot-loader div:nth-child(1){
          animation-delay:0s;
        }
        .three-dot-loader div:nth-child(2){
          animation-delay:0.2s;
        }
        .three-dot-loader div:nth-child(3){
          animation-delay:0.4s;
        }
        @keyframes scaling{
          0%, 100%{
            transform: scale(0.2);
            background-color: #BDBDBD;
          }
          33%{
            transform: scale(1);
            background-color: #848484;
          }
          66%{
            transform: scale(1);
            background-color: #000000;
          }
        }
      `}</style>
    </>
  )
}

const DeleteThreadModal = ({ open, setOpen, loading, handleDeleteConfirm, setDeleteId }: DeleteThreadModalProps) => {
  const handleCancelClick = () => {
    setOpen(false);
    setDeleteId('');
  }

  const handleDeleteClick = async () => {
    await handleDeleteConfirm();
    setOpen(false);
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[90%] max-w-[350px] py-4 px-8 bg-white gap-0">
        <div className="text-center font-bold text-lg leading-5 py-5 pb-7">Delete this thread</div>
        <DialogFooter className="sm:justify-center ga-4">
          <Button
            variant="secondary"
            className='rounded-lg w-[120px] bg-secondary hover:bg-secondary'
            onClick={handleCancelClick}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            className='rounded-lg w-[120px] bg-negative-red hover:bg-negative-red'
            onClick={handleDeleteClick}
            disabled={loading}
          >
            {loading ? <ThreeDotLoader2 /> : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default QueryEngine
